// extracted by mini-css-extract-plugin
export default {"root":"_3GvmE","custom-icon-button-size":"_2Uk22","customIconButtonSize":"_2Uk22"};